import React, { useRef, useEffect } from 'react';

function AnimaltHatterSeg() {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let animId;
    const resize = () => { canvas.width = canvas.offsetWidth; canvas.height = canvas.offsetHeight; };
    resize();
    window.addEventListener('resize', resize);
    const alakzatok = Array.from({length: 20}, () => ({
      x: Math.random() * canvas.width, y: Math.random() * canvas.height,
      meret: Math.random() * 60 + 20,
      vx: (Math.random() - 0.5) * 0.3, vy: (Math.random() - 0.5) * 0.3,
      szin: ['#1a73e8','#34a853','#9c27b0','#f9ab00','#00bcd4','#ea4335'][Math.floor(Math.random()*6)],
      alpha: Math.random() * 0.06 + 0.02,
      forgat: Math.random() * Math.PI * 2,
      forgSeb: (Math.random() - 0.5) * 0.008,
      tipus: Math.floor(Math.random() * 3),
    }));
    const rajzol = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      alakzatok.forEach(a => {
        a.x += a.vx; a.y += a.vy; a.forgat += a.forgSeb;
        if (a.x < -a.meret) a.x = canvas.width + a.meret;
        if (a.x > canvas.width + a.meret) a.x = -a.meret;
        if (a.y < -a.meret) a.y = canvas.height + a.meret;
        if (a.y > canvas.height + a.meret) a.y = -a.meret;
        ctx.save(); ctx.globalAlpha = a.alpha; ctx.fillStyle = a.szin;
        if (a.tipus === 0) {
          ctx.beginPath(); ctx.arc(a.x, a.y, a.meret/2, 0, Math.PI*2); ctx.fill();
        } else if (a.tipus === 1) {
          ctx.translate(a.x, a.y); ctx.rotate(a.forgat);
          ctx.beginPath(); ctx.moveTo(0, -a.meret/2); ctx.lineTo(a.meret/2*0.866, a.meret/4); ctx.lineTo(-a.meret/2*0.866, a.meret/4); ctx.closePath(); ctx.fill();
        } else {
          ctx.translate(a.x, a.y); ctx.rotate(a.forgat);
          ctx.fillRect(-a.meret/4, -a.meret/4, a.meret/2, a.meret/2);
        }
        ctx.restore();
      });
      animId = requestAnimationFrame(rajzol);
    };
    rajzol();
    return () => { cancelAnimationFrame(animId); window.removeEventListener('resize', resize); };
  }, []);
  return <canvas ref={canvasRef} style={{position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 0}}/>;
}

const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&display=swap');
  .segely-wrapper * { font-family: 'Nunito', sans-serif !important; }
  @keyframes felugrikSeg { 0% { transform: translateY(20px); opacity: 0; } 100% { transform: translateY(0); opacity: 1; } }
  .seg-kartya { transition: box-shadow 0.2s ease, transform 0.2s ease !important; }
  .seg-kartya:hover { box-shadow: 0 12px 36px rgba(0,0,0,0.12) !important; transform: translateY(-3px); }
`;

const segelyvonalak = [
  {
    csoport: '📞 Telefonos segélyvonalak',
    elemek: [
      { ikon: '💙', nev: 'Kék Vonal (gyerekeknek és fiataloknak)', ertek: '116-111', leiras: 'Ingyenes, éjjel-nappal, anonim módon hívható. Segít káros tartalmakkal, online zaklatással vagy visszaéléssel kapcsolatos ügyekben.', link: 'tel:116111', szin: '#1a73e8' },
      { ikon: '🛡️', nev: 'Gyermekvédő Hívószám', ertek: '06-80-212-021', leiras: 'A nap 24 órájában ingyenesen hívható, ha gyermeket vagy felnőttet érintő veszélyeztető helyzetet észlel.', link: 'tel:0680212021', szin: '#34a853' },
      { ikon: '⚖️', nev: 'Áldozatsegítő Vonal', ertek: '06-80-225-225', leiras: 'A hét minden napján, 0-24 órában, ingyenesen hívható bűncselekmények áldozatainak.', link: 'tel:0680225225', szin: '#9c27b0' },
      { ikon: '🚔', nev: 'Rendőrség', ertek: '107', leiras: 'Súlyos, azonnali beavatkozást igénylő esetekben.', link: 'tel:107', szin: '#ea4335' },
    ],
  },
  {
    csoport: '🌐 Online segítség és bejelentés',
    elemek: [
      { ikon: '🔗', nev: 'Internet Hotline (NMHH)', ertek: 'nmhh.hu/internethotline', leiras: 'Jogsértő vagy kiskorúak számára káros online tartalmak bejelentésére.', link: 'https://nmhh.hu/internethotline', szin: '#00bcd4' },
      { ikon: '🔗', nev: 'Biztonságos Internet Hotline', ertek: 'biztonsagosinternet.hu', leiras: 'A Nemzetközi Gyermekmentő Szolgálat által működtetett bejelentő és tájékoztató oldal szülőknek.', link: 'https://www.biztonsagosinternet.hu', szin: '#f9ab00' },
      { ikon: '🔗', nev: 'Adatvédelmi panaszok (NAIH)', ertek: 'naih.hu', leiras: 'Nemzeti Adatvédelmi és Információszabadság Hatóság - adatvédelmi jogsértések bejelentésére.', link: 'https://naih.hu', szin: '#1a73e8' },
    ],
  },
];

function SegelyvonalakOldal() {
  return (
    <div className="segely-wrapper" style={{minHeight: '100vh', background: 'linear-gradient(135deg, #f8f9ff 0%, #f0f7ff 50%, #f5fff8 100%)', padding: '3rem 2rem', position: 'relative', overflow: 'hidden'}}>
      <style>{globalStyles}</style>
      <AnimaltHatterSeg/>
      <div style={{position: 'relative', zIndex: 1, maxWidth: '900px', margin: '0 auto'}}>

        <div style={{textAlign: 'center', marginBottom: '3rem', animation: 'felugrikSeg 0.5s ease-out'}}>
          <div style={{display: 'inline-flex', alignItems: 'center', gap: '10px', background: 'rgba(255,255,255,0.9)', border: '2px solid #1a73e8', borderRadius: '50px', padding: '10px 24px', fontSize: '15px', fontWeight: '800', color: '#1a73e8', marginBottom: '1.25rem', boxShadow: '0 4px 16px rgba(26,115,232,0.12)'}}>
            <span style={{fontSize: '22px'}}>📞</span> Segélyvonalak
          </div>
          <h1 style={{fontSize: '38px', fontWeight: '900', color: '#1a1a2e', marginBottom: '0.75rem'}}>
            Hasznos <span style={{background: 'linear-gradient(135deg, #1a73e8, #34a853)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text'}}>elérhetőségek</span>
          </h1>
          <p style={{fontSize: '16px', color: '#666', maxWidth: '520px', margin: '0 auto', fontWeight: '600', lineHeight: 1.7}}>
            Ha segítségre van szüksége - akár Ön, akár gyermeke érintett -, ezek a szolgálatok ingyenesen elérhetők. 🛡️
          </p>
        </div>

        {segelyvonalak.map((csoport) => (
          <div key={csoport.csoport} style={{marginBottom: '2.5rem', animation: 'felugrikSeg 0.5s ease-out'}}>
            <h2 style={{fontSize: '20px', fontWeight: '900', color: '#1a1a2e', marginBottom: '1.25rem'}}>{csoport.csoport}</h2>
            <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
              {csoport.elemek.map((e) => (
                <a key={e.nev} href={e.link} target={e.link.startsWith('http') ? '_blank' : undefined} rel={e.link.startsWith('http') ? 'noopener noreferrer' : undefined}
                  className="seg-kartya"
                  style={{background: 'rgba(255,255,255,0.95)', borderRadius: '20px', padding: '1.25rem 1.5rem', display: 'flex', alignItems: 'center', gap: '16px', textDecoration: 'none', border: '2px solid #f0f0f0', boxShadow: '0 4px 16px rgba(0,0,0,0.05)'}}>
                  <div style={{width: '52px', height: '52px', borderRadius: '16px', background: e.szin + '18', border: '1.5px solid ' + e.szin + '40', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px', flexShrink: 0}}>
                    {e.ikon}
                  </div>
                  <div style={{flex: 1, minWidth: 0}}>
                    <div style={{fontSize: '16px', fontWeight: '800', color: '#1a1a2e', marginBottom: '2px'}}>{e.nev}</div>
                    <div style={{fontSize: '14px', color: '#888', lineHeight: 1.5}}>{e.leiras}</div>
                  </div>
                  <div style={{fontSize: '16px', fontWeight: '900', color: e.szin, whiteSpace: 'nowrap', flexShrink: 0}}>{e.ertek}</div>
                </a>
              ))}
            </div>
          </div>
        ))}

        <div style={{textAlign: 'center', marginTop: '2rem'}}>
          <a href="/" style={{color: '#1a73e8', fontWeight: '800', fontSize: '15px', textDecoration: 'none'}}>← Vissza a főoldalra</a>
        </div>

      </div>
    </div>
  );
}

export default SegelyvonalakOldal;